import React from "react";
import { Card, Icon, Image, Button, Popup, Label, Header } from "semantic-ui-react";
import ButtonBarcodeTube from "features/FolderManager/components/Tubes/ButtonBarcodeTube";
import SecondaryRedButton from "components/Buttons/SecondaryRedButton";
import RedButton from "components/Buttons/RedButton";
import DatePicker, { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr"; // the locale you want
import moment from "moment";
// import Analysis from '../Prescription/Analysis';
// import BlueButtonEditBloc from 'components/Buttons/BlueButtonEditBloc';
import { getTimeBetweenInSec } from "utils/dateUtils";
registerLocale("fr", fr);

const styles = {
	content: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexWrap: "wrap",
		cursor: "pointer",
		position: "relative",
	},
	alertBadge: {
		position: "absolute",
		top: "-15px",
		right: "-15px",
		height: 30,
		width: 30,
		borderRadius: 15,
		backgroundColor: "#9f0009",
		border: "1px solid #fff",
		textAlign: "center",
	},
	addedBadge: {
		position: "absolute",
		top: "-15px",
		left: "-15px",
		height: 30,
		width: 30,
		borderRadius: 15,
		backgroundColor: "#9f0009",
		border: "1px solid #fff",
		textAlign: "center",
	},
	badgeIcon: {
		position: "relative",
		bottom: "-2px",
		marginRight: 0,
		color: "#fff",
	},
	timer: {
		backgroundColor: "darkorange",
		padding: "2px 7px",
		borderRadius: "15px",
		margin: "5px",
		color: "white",
	},
	timerAvailable: {
		backgroundColor: "teal",
		padding: "2px 7px",
		borderRadius: "15px",
		margin: "5px",
		color: "white",
	},
	timerLate: {
		backgroundColor: "red",
		padding: "2px 7px",
		borderRadius: "15px",
		margin: "5px",
		color: "white",
	},
};

const TubeCard = ({
	tube,
	isHome,
	onUntaken,
	openBarcode,
	take_number,
	openTubeDetails,
	openDeleteNotPrescribedTubeConfirm,
	disabled,
	patchTubeSamplingTime,
	openReuseTubeModal,
	openConfirmCancelReuseTube,
	openNatureTubeModal,
	isSelected = false,
	canReuseTube = false,
	covidBackgroundColor,
	waitingFirstSampling,
	timer,
	safeplaceResult,
	urgencyPretreatementLimit,
	aliquot,
	aliquotPrimary,
	submitBarCode,
	regex,
	cancelSelect,
	selectTube,
	openNotesDetails,
}) => {
	// const analysisHasWarning = (analysis) =>
	// 	analysis.urgent ||
	// 	analysis.special_diet ||
	// 	(isHome && (analysis.home_prohibited || analysis.home_not_recommended)) ||
	// 	analysis.fasting ||
	// 	analysis.light_protected ||
	// 	analysis.required_consent ||
	// 	(analysis.taking_note !== '' && analysis.taking_note !== null) ||
	// 	analysis.subcontracting;

	const timing = (tube) => Math.floor(Math.abs(getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_result, "m")) / 60));
	return (
		<Card
			style={{
				marginRight: 5,
				marginLeft: 5,
				marginBottom: 10,
				width: "unset",
				backgroundColor: timer !== "" || waitingFirstSampling > 0 ? "lightgrey" : isSelected ? "#f2711c36" : covidBackgroundColor(tube) ?? "white",
			}}
			color={timer !== "" || waitingFirstSampling > 0 ? "grey" : isSelected ? "yellow" : "black"}
		>
			{tube.analyses && tube.analyses.some((a) => a.properties.pretreatment_note || a.properties.taking_note) && (
				<Popup
					content="Notes pour le prélèvement et/ou le pré-traitement"
					position="top center"
					trigger={
						<Label
							as="a"
							onClick={(e) => {
								if (e !== undefined) e.preventDefault();
								openNotesDetails(tube);
							}}
							color="teal"
						>
							<span style={{ fontSize: "1.4em", padding: "0 1.3em" }}>
								{" "}
								<Icon name="sticky note outline" />
								Notes
							</span>
						</Label>
					}
				/>
			)}
			{tube.analyses &&
				tube.analyses.filter((a) => a.properties.pretreatment_stability > 0).length > 0 &&
				Math.min(...tube.analyses.filter((a) => a.properties.pretreatment_stability > 0).map((t) => t.properties.pretreatment_stability)) <=
					urgencyPretreatementLimit && (
					<Popup
						content="ATTENTION ! Pré-traitement urgent : cliquez sur le tube puis sur la/les analyse/s concernées."
						position="top center"
						trigger={
							<Label color="red" corner="right" size="big" style={{ paddingTop: "5px" }}>
								<span style={{ fontSize: "1.4em", padding: "0 1.3em" }}>
									{Math.min(...tube.analyses.filter((a) => a.properties.pretreatment_stability > 0).map((t) => t.properties.pretreatment_stability)) >
									59
										? Math.min(
												...tube.analyses.filter((a) => a.properties.pretreatment_stability > 0).map((t) => t.properties.pretreatment_stability)
										  ) === 90
											? "90m"
											: Math.min(
													...tube.analyses.filter((a) => a.properties.pretreatment_stability > 0).map((t) => t.properties.pretreatment_stability)
											  ) /
													60 +
											  "h"
										: Math.min(
												...tube.analyses.filter((a) => a.properties.pretreatment_stability > 0).map((t) => t.properties.pretreatment_stability)
										  ) + "'"}
								</span>
							</Label>
						}
					/>
				)}
			<Card.Content
				style={styles.content}
				onClick={(e) => {
					if (e !== undefined) e.preventDefault();
					openTubeDetails(tube);
				}}
			>
				<Image
					floated="left"
					size="tiny"
					src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${
						tube.properties.picto !== null ? tube.properties.picto.filename : process.env.REACT_APP_TUBE_PIC_FILENAME
					}`}
					style={{ marginRight: 0, padding: "0 0px" }}
				/>
				{/* {tube.analyses.filter(a => a.properties.pretreatment_stability > 0).length > 0 && Math.min(...tube.analyses.filter(a => a.properties.pretreatment_stability > 0).map(t => t.properties.pretreatment_stability) ) <= urgencyPretreatementLimit && 
					<Label  horizontal color='red'><Icon name='hourglass' /> {Math.min(...tube.analyses.filter(a => a.properties.pretreatment_stability > 0).map(t => t.properties.pretreatment_stability))/60}h </Label>
				} */}

				<Card.Header style={{ width: "100%", textAlign: "center", minHeight: "55px", margin: "auto 0" }}>{tube.properties.label}</Card.Header>
				{tube.properties.timer_before_result > 0 && (
					<Card.Description style={{ textAlign: "center" }}>
						Test rapide
						{safeplaceResult && " - Résultat sauvegardé"}
						{!safeplaceResult && !tube.sampling_time && <div>{tube.properties.timer_before_result} min avant de connaitre le résultat</div>}
						{!safeplaceResult &&
							tube.sampling_time &&
							getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_result, "m")) > 0 && (
								<div>
									<span style={styles.timer}>{timing(tube)} min </span>avant de connaitre le résultat
								</div>
							)}
						{!safeplaceResult &&
							tube.sampling_time &&
							getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_result, "m")) < 0 &&
							getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_result, "m")) > -900 && (
								<Label color="green" style={styles.timerAvailable}>
									Test à lire ({timing(tube)} min)
								</Label>
							)}
						{!safeplaceResult &&
							tube.sampling_time &&
							getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_result, "m")) < -900 && (
								<div style={styles.timerLate}>Lecture en retard ({timing(tube)} min)</div>
							)}
					</Card.Description>
				)}
				{tube.added_reason !== null && (
					<>
						<Card.Description>Ajout : {tube.added_reason}</Card.Description>
						<div style={styles.addedBadge}>
							<Icon size="small" name="plus" style={styles.badgeIcon} />
						</div>
					</>
				)}
				{tube.nature_reason && <Card.Description>Nature : {tube.nature_reason}</Card.Description>}
				{/* {(tube.light_protected || tube.pretreatment_urgent) && (
					<div style={styles.alertBadge}>
						<Icon size='small' name='warning' style={styles.badgeIcon} />
					</div>
				)} */}
			</Card.Content>

			{/* 	{tube.analyses && (
				<Card.Content>
					<Grid>
						<Grid.Row>
							<Grid.Column
								style={{
									display: 'flex',
									flexWrap: 'wrap',
									justifyContent: 'center',
									fontSize:'0.8em'
								}}
							>
								{tube.analyses
									//Put the analyses with warnings first
									.sort((a1, a2) => {
										const a1HasWarning = analysisHasWarning(a1.properties);
										const a2HasWarning = analysisHasWarning(a2.properties);
										return a1HasWarning === a2HasWarning
											? 0
											: a1HasWarning
											? -1
											: 1;
									})
									
									.map((ana) => (
										<div key={`anadiv-${ana.id}-${ana.properties?.id}`} style={{border:'1px solid rgb(95, 155, 224)', padding: '3px', margin: '3px', borderRadius: '10px',	color: 'rgb(95,155,224)'}}>
										<Analysis
											analysis={ana.properties ?? ana}
											onClick={() => openAnalysisDetailsModal(ana.properties ?? ana)}
											showWarning={false}
											isHome={isHome}
											showRefused={false}
										/>
										</div>
									))}
								
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Card.Content>
			)} */}

			<Card.Content style={{ minHeight: "150px" }}>
				{tube.status !== "UNTAKEN" &&
					tube.properties.take_number_before_display <= take_number &&
					(timer === "" || timer === "maintenant") &&
					waitingFirstSampling === 0 && (
						<ButtonBarcodeTube
							key={"barcode" + tube.properties_id}
							barcode={tube.provider_barcode}
							submitBarCode={submitBarCode}
							regex={regex}
							isSelected={isSelected}
							onClick={(e) => {
								if (e !== undefined) e.preventDefault();
								openBarcode(tube);
							}}
							disabled={disabled || !tube.original}
							cancelSelect={() => cancelSelect()}
							select={() => selectTube(tube)}
							aliquotPrimary={aliquot ? aliquotPrimary : null}
						/>
					)}

				{canReuseTube > 0 && tube.original && !disabled && (
					<Button
						content="Réutiliser un tube"
						onClick={(e) => {
							if (e !== undefined) e.preventDefault();
							openReuseTubeModal(tube);
						}}
						disabled={disabled}
						style={{ width: "100%" }}
						color="green"
					/>
				)}

				{!tube.original && (
					<Button
						content="Annuler la réutilisation"
						onClick={(e) => {
							if (e !== undefined) e.preventDefault();
							openConfirmCancelReuseTube(tube);
						}}
						disabled={disabled}
						style={{ width: "100%" }}
						color="red"
					/>
				)}

				{tube.status === "NEW" &&
					tube.properties.take_number_before_display <= take_number &&
					timer === "" &&
					waitingFirstSampling === 0 &&
					tube.original && (
						<SecondaryRedButton
							text="Tube non prélevé"
							style={{
								marginTop: 10,
								marginBottom: 10,
								width: "100%",
								textTransform: "uppercase",
								fontSize: "0.8em",
							}}
							onClick={(e) => {
								if (e !== undefined) e.preventDefault();
								onUntaken(tube);
							}}
							disabled={disabled}
						/>
					)}
				{tube.status === "UNTAKEN" && tube.properties.take_number_before_display <= take_number && (
					<RedButton
						text={`Non prélevé: ${tube.untaken_reason}`}
						style={{
							marginTop: 10,
							marginBottom: 10,
							width: "100%",
							textTransform: "uppercase",
							fontSize: "0.8em",
						}}
						onClick={(e) => {
							if (e !== undefined) e.preventDefault();
							onUntaken(tube);
						}}
						disabled={disabled}
					/>
				)}
				{tube.status === "NEW" && tube.properties.take_number_before_display <= take_number && timer !== "" && (
					<div style={{ width: "100%", textAlign: "center", color: "brown" }}>
						<Icon size="big" name="wait" />
						<span>{timer}</span>
					</div>
				)}

				{tube.added_reason !== null && (
					<SecondaryRedButton
						text="Supprimer"
						style={{
							marginTop: 10,
							marginBottom: 10,
							width: "100%",
							textTransform: "uppercase",
							fontSize: "0.8em",
						}}
						onClick={(e) => {
							if (e !== undefined) e.preventDefault();
							openDeleteNotPrescribedTubeConfirm(tube);
						}}
						disabled={disabled}
					/>
				)}

				{waitingFirstSampling > 0 && (
					<div style={{ fontSize: "0.8em", width: "100%", textAlign: "center" }}>
						Tube à prélever {waitingFirstSampling} minutes après le 1e prélèvement
					</div>
				)}

				{tube.sampling_time && (
					<div>
						Heure de prélèvement:{" "}
						<DatePicker
							selected={moment(tube.sampling_time).toDate()}
							onChange={(date) => patchTubeSamplingTime(tube, date)}
							showTimeSelect
							timeFormat={process.env.REACT_APP_TIME_DISPLAY_FORMAT}
							timeIntervals={5}
							timeCaption="time"
							dateFormat={`${process.env.REACT_APP_DATE_DATEPICKER}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`}
							locale="fr"
							className="custom-input"
							disabled={disabled || !tube.original}
							calendarClassName="calendar-container"
						/>
					</div>
				)}

				{tube.nature_reason && (
					<Button
						content={`Modifier motif nature multiple`}
						color="blue"
						style={{
							marginTop: 10,
							marginBottom: 10,
							width: "100%",
							fontSize: "0.8em",
						}}
						onClick={(e) => {
							if (e !== undefined) e.preventDefault();
							openNatureTubeModal(tube);
						}}
						disabled={disabled}
					/>
				)}
			</Card.Content>
			{aliquot && aliquotPrimary && (
				<Card.Content>
					<Header as="h5" style={{ marginBottom: "4px" }}>
						<Icon name="linkify" />
						Tube primaire{" "}
					</Header>
					<div style={{ display: "flex", alignItems: "flex-start" }}>
						<Image
							floated="left"
							size="mini"
							src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${
								aliquotPrimary.properties.picto !== null ? aliquotPrimary.properties.picto.filename : process.env.REACT_APP_TUBE_PIC_FILENAME
							}`}
							style={{ marginRight: 0, padding: "0 0px" }}
						/>
						<div style={{ display: "flex", flexDirection: "column", marginLeft: "5px" }}>
							<span>{aliquotPrimary.properties.label} </span>
							{aliquotPrimary.provider_barcode && (
								<span>
									<Icon name="barcode" />{" "}
									{aliquotPrimary.provider_barcode.replace(
										aliquotPrimary.provider_barcode.substring(0, aliquotPrimary.provider_barcode.length - 4),
										"XXXXXX"
									)}
								</span>
							)}
							{!aliquotPrimary.provider_barcode && "Non scanné"}
						</div>
					</div>
				</Card.Content>
			)}
		</Card>
	);
};

export default TubeCard;
